"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var Helpers = require("helpers");
var PreorderLabel = function () { return (React.createElement(React.Fragment, null,
    React.createElement("br", null),
    "Pre-Order")); };
var CartItem = /** @class */ (function (_super) {
    __extends(CartItem, _super);
    function CartItem(props) {
        var _this = _super.call(this, props) || this;
        _this.checkPreorder = function (lineitem) {
            var _a, _b;
            if (((_b = (_a = lineitem) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b["Pre-Order"]) && lineitem.inventory_quantity < 1 && lineitem.inventory_policy === "continue") {
                return true;
            }
            return false;
        };
        _this.handleQtyChange = function (type) {
            var _a = _this.props, quantity = _a.quantity, lineitem = _a.lineitem;
            var newQuantity = quantity;
            if (type === "+") {
                newQuantity += 1;
            }
            if (type === "-") {
                newQuantity -= 1;
            }
            if (quantity !== newQuantity) {
                next_components_1.ShopifyNext.Cart.updateQty(lineitem.key, newQuantity);
                _this.setState({ quantity: newQuantity, didForceUpdate: true });
            }
        };
        _this.handleRemove = function (lineitem) {
            next_components_1.ShopifyNext.Cart.removeItem(lineitem.key);
            _this.setState({ quantity: 0, didForceUpdate: true });
        };
        _this.state = {
            quantity: _this.props.quantity,
            didForceUpdate: false,
        };
        _this.handleQtyChange = _this.handleQtyChange.bind(_this);
        return _this;
    }
    CartItem.prototype.componentDidUpdate = function () {
        if (this.state.quantity !== this.props.lineitem.quantity && !this.state.didForceUpdate) {
            this.setState({
                quantity: this.props.lineitem.quantity,
            });
        }
        if (this.state.quantity === this.props.lineitem.quantity && this.state.didForceUpdate) {
            this.setState({
                didForceUpdate: false,
            });
        }
    };
    CartItem.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        var _h = this.props, drawer = _h.drawer, lineitem = _h.lineitem, cncSelected = _h.cncSelected, data = _h.data, cncStore = _h.cncStore, stockInStore = _h.stockInStore;
        var offers = [];
        var isPreorder = this.checkPreorder(lineitem);
        if ((_a = lineitem.discounts) === null || _a === void 0 ? void 0 : _a.length) {
            lineitem.discounts.map(function (item) { return offers.push(item.title); });
        }
        if (lineitem.compare_at_price > lineitem.price) {
            offers.push("Save " + Math.floor((lineitem.price / lineitem.compare_at_price) * 100) + "%");
        }
        var isOutofStock = lineitem.inventory_quantity < 1 && lineitem.inventory_policy === "deny" && !lineitem.product_type.toLowerCase().includes("gift card");
        var preorder = (_d = (_c = (_b = lineitem) === null || _b === void 0 ? void 0 : _b.preorderme) === null || _c === void 0 ? void 0 : _c.product_settings) === null || _d === void 0 ? void 0 : _d[(_e = lineitem) === null || _e === void 0 ? void 0 : _e.variant_id];
        var maxQuantity = ((_f = preorder) === null || _f === void 0 ? void 0 : _f.qty) - ((_g = preorder) === null || _g === void 0 ? void 0 : _g.sold) || lineitem.inventory_quantity;
        // TODO: cleanup the expression below...
        var image = lineitem.image && lineitem.image.src ? lineitem.image.src : lineitem.image ? lineitem.image : null;
        if (drawer) {
            return (React.createElement("div", { className: "border-b border-grey-light", key: lineitem.key },
                React.createElement("div", { className: "flex py-1-6 md:px-1-6 transition-fast " + (!this.state.quantity ? "pointer-events-none opacity-50" : "") },
                    React.createElement("div", { className: "w-1/4 pr-0-6" },
                        React.createElement("a", { href: lineitem.url, title: lineitem.product_title, className: "block w-full no-underline" },
                            React.createElement(Snippets.Image, { imageAttributes: "border border-blue-grey rounded", src: image, ratio: "7:8", bgNatural: true, width: 84, alt: "" }))),
                    React.createElement("div", { className: "w-3/4 pl-0-6 flex flex-col items-start justify-between" },
                        React.createElement("div", { className: "w-full flex flex-row justify-between items-start" },
                            React.createElement("a", { href: lineitem.url, title: lineitem.product_title, className: "block no-underline" },
                                React.createElement(Snippets.Heading, { size: "h1", tag: "p", className: "text-base font-semibold uppercase leading-tightest" },
                                    Helpers.lineItemTitle(lineitem.product_title, lineitem.options_with_values.map(function (option) { return option.value; })),
                                    isPreorder && React.createElement(PreorderLabel, null))),
                            React.createElement("button", { className: "flex items-center justify-end uppercase font-bold text-base text-blue-grey hover:text-midnight transition-fast focus:outline-none", onClick: function () { return _this.handleRemove(lineitem); }, type: "button" },
                                React.createElement(Snippets.Svg, { name: "cross", height: 12, className: "block" }))),
                        React.createElement("div", { className: "w-full" },
                            React.createElement("div", { className: "w-full flex flex-col items-start justify-between" },
                                React.createElement(Snippets.CartItemTotalPrice, { lineitem: lineitem, format: data.shop.money_format, className: "text-base mb-1-2", inline: true, sale: true }),
                                React.createElement(Snippets.CartItemQty, { isOutofStock: isOutofStock, quantity: lineitem.quantity, handleClick: this.handleQtyChange, max: maxQuantity, className: "max-w-6" + (this.state.quantity !== lineitem.quantity || isOutofStock ? "" : ""), isPreorder: isPreorder })))))));
        }
        return (React.createElement("div", { className: "border-b border-grey-light py-1-6 transition-fast " + (!this.state.quantity ? "pointer-events-none opacity-50" : ""), key: lineitem.key },
            React.createElement("div", { className: "flex flex-row" },
                React.createElement("div", { className: "w-5/8 flex flex-row" },
                    React.createElement("div", { className: "w-9-8 mr-2-5" },
                        React.createElement("a", { href: lineitem.url, title: lineitem.product_title, className: "block w-full no-underline" },
                            React.createElement(Snippets.Image, { imageAttributes: "border border-blue-grey rounded", src: lineitem.image ? lineitem.image.src : null, ratio: "1:1", alt: "" }))),
                    React.createElement("div", { className: "w-3/5 relative" },
                        React.createElement("a", { href: lineitem.url, title: lineitem.product_title, className: "block no-underline mb-0-8" },
                            React.createElement(Snippets.Heading, { size: "h1", tag: "p", className: "text-base leading-none font-semibold uppercase tracking-wide" },
                                Helpers.lineItemTitle(lineitem.product_title, lineitem.options_with_values.map(function (option) { return option.value; })),
                                isPreorder && React.createElement(PreorderLabel, null))),
                        React.createElement("div", { className: "absolute pin-b" },
                            isOutofStock && (React.createElement("div", null,
                                React.createElement("span", { className: "absolute h-1-6 w-1-6 bg-red rounded-half" },
                                    React.createElement(Snippets.Svg, { name: "clear", width: 20, className: "text-arctic absolute transform" })),
                                React.createElement("span", { className: "ml-2-4 block text-xs font-normal normal-case overflow-visible" }, "Currently out of stock. Please remove this item from your bag before checking out"))),
                            cncSelected && (React.createElement(React.Fragment, null, stockInStore ? (React.createElement("div", null,
                                React.createElement("span", { className: "absolute h-1-6 w-1-6 bg-red rounded-half" },
                                    React.createElement(Snippets.Svg, { name: "clear", width: 20, className: "text-arctic absolute transform" })),
                                React.createElement("span", { className: "ml-2-4 block text-xxs font-normal normal-case overflow-visible" },
                                    "Currently out of stock at",
                                    " ",
                                    cncStore || "selected store",
                                    ". Please select another store or remove it from your bag before checking out."))) : (React.createElement("div", null,
                                React.createElement("span", { className: "absolute h-1-6 w-1-6 bg-green rounded-half" },
                                    React.createElement(Snippets.Svg, { name: "check", width: 20, className: "text-arctic absolute transform" })),
                                React.createElement("span", { className: "ml-2-4 block text-xxs font-normal normal-case overflow-visible" },
                                    "Available at",
                                    " ",
                                    cncStore || "selected store",
                                    ".")))))))),
                React.createElement("div", { className: "w-1/8" },
                    React.createElement(Snippets.CartItemOptions, { className: "flex flex-col text-base items-start justify-start", lineitem: lineitem })),
                React.createElement("div", { className: "w-1/8 flex items-start justify-center" },
                    React.createElement(Snippets.CartItemQty, { isOutofStock: isOutofStock, quantity: lineitem.quantity, handleClick: this.handleQtyChange, max: maxQuantity, className: "max-w-6" + (this.state.quantity !== lineitem.quantity || isOutofStock ? " pointer-events-none opacity-50" : ""), isPreorder: isPreorder })),
                React.createElement("div", { className: "w-1/8 flex flex-col justify-between" },
                    React.createElement(Snippets.CartItemTotalPrice, { lineitem: lineitem, format: data.shop.money_format, className: "text-base font-semibold flex flex-col items-end", sale: true }),
                    React.createElement("button", { className: "flex items-center justify-end uppercase font-bold text-base text-blue-grey hover:text-midnight transition-fast focus:outline-none", onClick: function () { return _this.handleRemove(lineitem); }, type: "button" },
                        React.createElement(Snippets.Svg, { name: "cross", height: 12, className: "block" }),
                        React.createElement("p", { className: "text-base ml-0-8" }, "Remove"))))));
    };
    return CartItem;
}(React.PureComponent));
exports.CartItem = CartItem;
